module.exports = __webpack_public_path__ + "img/icon-html5&css3.8b8172de.svg";